import React from "react";
import ResourceField, { ResourceFieldType } from "./components/ResourceField";
import { Container, Header, Title, Body, Main, Divider } from "./styles";

const Resource = ({ resource, hasDivider }) => {
	const {
		title,
		body,
		streetAddress,
		city,
		state,
		zipCode,
		hours,
		websiteUrlLabel,
		websiteUrl,
		phoneNumber,
		ttyNumber,
		ttyInstructions,
		smsNumber,
		smsLabel,
		smsPrefill,
	} = resource;

	return (
		<Container>
			<Header>
				<Title type="h4">{title}</Title>
				<Body>{body}</Body>
			</Header>
			<Main>
				{websiteUrl ? (
					<ResourceField
						type={ResourceFieldType.Website}
						websiteUrlLabel={websiteUrlLabel}
						websiteUrl={websiteUrl}
					/>
				) : null}
				{streetAddress ? (
					<ResourceField
						type={ResourceFieldType.Location}
						title={title}
						streetAddress={streetAddress}
						city={city}
						state={state}
						zipCode={zipCode}
					/>
				) : null}
				{phoneNumber ? (
					<ResourceField
						type={ResourceFieldType.Phone}
						phoneNumber={phoneNumber}
					/>
				) : null}
				{smsNumber ? (
					<ResourceField
						type={ResourceFieldType.Sms}
						smsNumber={smsNumber}
						smsLabel={smsLabel}
						smsPrefill={smsPrefill}
					/>
				) : null}
				{ttyNumber || ttyInstructions ? (
					<ResourceField
						type={ResourceFieldType.TTY}
						ttyNumber={ttyNumber}
						ttyInstructions={ttyInstructions}
					/>
				) : null}
				{hours ? (
					<ResourceField
						type={ResourceFieldType.Hours}
						hours={hours}
					/>
				) : null}
			</Main>
			{hasDivider && <Divider />}
		</Container>
	);
};

export default Resource;
